import {Component, OnInit} from '@angular/core';
import {ExamesNaviosService} from "./exames-navios.service";
import {ExamesNaviosModel} from "./exames-navios.model";
import {Global} from "../../global";
import {Components} from "../../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../../funcoes";
import {LoginService} from "../../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-exames-navios',
  templateUrl: './exames-navios.component.html'
})
export class ExamesNaviosComponent extends Components implements OnInit {

  navios: ExamesNaviosModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private examesNaviosService: ExamesNaviosService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao && data.privilegios[i].acao[0] && (data.privilegios[i].acao[0].url == 'exames' || data.privilegios[i].id_acao == '33')){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.examesNaviosService.getPaginacao(1, this.itensPorPagina)
      .subscribe(data => {
        this.navios = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.navios);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  delete(navio) {
    let navios = this.navios;
    let examesNaviosService = this.examesNaviosService;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarNavio') + ': ' + navio.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      () => {
        if(this.global.debug == true){
          console.log(navios);
        }

        let index = navios.indexOf(navio);
        navios.splice(index, 1);

        examesNaviosService.apagar(navio.id)
          .subscribe(res => {
              this.navios = navios;
            },
            err => {
              navios.splice(index, 0, navio);
              this.navios = navios;
              this.func.showErro(err.json());
            });
      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.examesNaviosService.getPaginacao(pagina, this.itensPorPagina)
      .subscribe(data => {
        this.navios = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/exames/navios/exames-navios.component.ts